export const toSingular = (value) => {
  let word = value.charAt(0).toUpperCase() + value.slice(1);
  if (word.endsWith("ies")) {
    return word.slice(0, -3) + "y";
  } else if (word.endsWith("s")) {
    return word.slice(0, -1);
  }
  return word;
};
